// extracted by mini-css-extract-plugin
export default {"imageWithTextContainer":"ContactForm_imageWithTextContainer__kfuDs","container":"ContactForm_container__6YqIN","customPhoneInput":"ContactForm_customPhoneInput__70ep1"};